/**
 * Labstep
 *
 * @module components/Metadata/Action/Create/Modal/Wizard/MetadataActionCreateModalWizardStepRestrictCategory
 * @desc Step 1: Restrict Category - Select which category of resources to link to
 */

import type { IValues } from 'labstep-web/core/Form/Reusable/types';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { Resource } from 'labstep-web/models/resource.model';
import type React from 'react';
import { Form } from 'semantic-ui-react';

interface MetadataActionCreateModalWizardStepRestrictCategoryProps {
  formValues: IValues;
  onFormChange: (values: IValues) => void;
}

export const MetadataActionCreateModalWizardStepRestrictCategory: React.FC<
  MetadataActionCreateModalWizardStepRestrictCategoryProps
> = ({ formValues, onFormChange }) => {
  return (
    <Form>
      <Form.Field>
        <SearchSelect
          entityName={Resource.entityName}
          searchKey="search_query"
          params={{ is_template: true }}
          value={
            formValues.entity_relation_target_entity_filter_template as Resource
          }
          creatable
          createBody={{ is_template: true }}
          onChange={(value) => {
            const updates: IValues = {
              entity_relation_target_entity_filter_template: value,
              entity_relation_target_entity_filter_template_id:
                value?.id || value?.guid,
            };

            // Pre-populate Field Name with the selected template name
            if (value?.name && !formValues.label) {
              updates.label = value.name;
            }

            // Pre-populate Inverse Field Name with current entity name (for asymmetric)
            const currentEntity = formValues.current_entity as any;
            if (currentEntity?.name && !formValues.inverse_relation) {
              updates.inverse_relation = currentEntity.name;
            }

            onFormChange(updates);
          }}
        />
      </Form.Field>
    </Form>
  );
};
